import { CreateNewsletterQueueAIParams, CreateNewsletterRemixQueueAIParams } from "../types/requestInputs";
import { CreateNewsletterQueueAIResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

export const createNewsletterQueueAI = async ({
    token,
    isFromDb,
    dbSourceId,
    language,
    textObject,
    numberOfWords,
    audience,
    textTitle,
    numberStories,
    requiredContent,
    queryFilters,
    restrictToDatabase,
    brandVoiceId,
    audienceProfileId,
}: CreateNewsletterQueueAIParams): Promise<CreateNewsletterQueueAIResponse> => {
    return fetchAPI<CreateNewsletterQueueAIResponse>(
        "/add-one-newsletter-text-item-queue",
        "POST",
        {
            isFromDb,
            dbSourceId,
            language,
            textObject,
            numberOfWords,
            audience,
            textTitle,
            numberStories,
            requiredContent,
            queryFilters,
            restrictToDatabase,
            brandVoiceId: brandVoiceId || null,
            audienceProfileId: audienceProfileId || null,
        },
        token,
    );
};

export const createNewsletterRemixQueueAI = async ({
    token,
    language,
    textObject,
    textTitle,
    remixPrompt,
}: CreateNewsletterRemixQueueAIParams): Promise<CreateNewsletterQueueAIResponse> => {
    return fetchAPI<CreateNewsletterQueueAIResponse>(
        "/add-one-newsletter-remix-item-queue",
        "POST",
        {
            language,
            textObject,
            textTitle,
            remixPrompt,
        },
        token,
    );
};
